import { FileSpreadsheet, FileText, Link2, Presentation, Video, type LucideIcon } from "lucide-react";
import { googleDriveTypeLabel } from "@/lib/google-drive-labels";
import type { SessionMaterial } from "@/lib/api/sessionPortal";

/** A row's kind, as an icon. A lookup over what the resource IS. */
export function materialIcon(material: SessionMaterial): LucideIcon {
  const mime = material.google_drive_mime_type?.toLowerCase() ?? "";
  if (mime.includes("presentation") || mime.includes("powerpoint")) return Presentation;
  if (mime.includes("spreadsheet") || mime.includes("excel") || mime === "text/csv") return FileSpreadsheet;
  if (mime.startsWith("video/")) return Video;
  if (!mime && /link|url/i.test(material.material_type)) return Link2;
  return FileText;
}

/** A row's kind, in words: the Drive type when the material lives on Drive. */
export function materialKind(material: SessionMaterial): string | null {
  return googleDriveTypeLabel(material.google_drive_mime_type)
    ?? (/link|url/i.test(material.material_type) ? "Link" : null);
}
